<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Clientes</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-outline-brand mr-2 dropdown-toggle"
                      type="button"
                      id="OmieButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-sync-alt"></i> Omie
                      <span
                        v-if="omieAlerts.sync > 0"
                        class="badge badge-danger ml-1"
                        title="Erros de sincronização não vistos"
                        >{{ formatAlertCount(omieAlerts.sync) }}</span
                      >
                    </button>
                    <div class="dropdown-menu" aria-labelledby="OmieButton">
                      <a href="#" class="dropdown-item" @click.prevent.stop="syncOmie(1)"
                        ><i class="fas fa-angle-right m--font-metal"></i> Sincronizar todos os
                        clientes</a
                      >
                      <a href="#" class="dropdown-item" @click.prevent.stop="syncOmie(2)"
                        ><i class="fas fa-angle-right m--font-metal"></i> Sincronizar novos
                        clientes</a
                      >
                      <a href="#" class="dropdown-item" @click.prevent.stop="openOmieSyncLogs()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Logs sincronização
                        clientes
                        <span
                          v-if="omieAlerts.sync > 0"
                          class="badge badge-danger ml-1"
                          >{{ formatAlertCount(omieAlerts.sync) }}</span
                        ></a
                      >
                    </div>
                  </div>
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos cliente">
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="syncContaAzul()"
                      v-b-tooltip.hover
                      title="Sincronizar com a Conta Azul!"
                    >
                      <i class="fas fa-sync-alt"></i>&nbsp; Conta Azul
                    </span>
                  </div>
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu dos contratos"
                    v-if="canManageCustomers"
                  >
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveCustomer('add')"
                      v-b-tooltip.hover
                      title="Novo Cliente!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType !== 'id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="200">Cliente</td>
                      <td nowrap class="text-center align-middle" width="150">Documento</td>
                      <td nowrap class="text-center align-middle" width="50">Status</td>
                      <td nowrap class="text-center align-middle" width="80">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectCustomerStatuses
                          :first="'Todos'"
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(customer, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ customer.id }}</td>
                      <td class="text-left align-middle">
                        {{
                          customer.customerable.co_name
                            ? customer.customerable.co_name
                            : customer.customerable.name
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.value ? customer.value : '-' | cnpj | cpf }}
                      </td>
                      <td nowrap class="text-center align-middle">
                        <span
                          class="m--font-success"
                          v-if="customer.status === 1"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Ativo</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 2"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Cancelado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 3"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Bloqueado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 4"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Congelado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 5"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Mudança de documento</span
                        >
                      </td>
                      <td nowrap class="text-center align-middle">
                        <a
                          href="#"
                          @click.prevent.stop="openSaveCustomer(customer.id, customer.type)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Cadastro"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          href="#"
                          @click.prevent.stop="syncOmie(3, customer.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Sincronizar com Omie"
                        >
                          <i class="fas fa-sync-alt"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerModal v-if="showCustomerSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveCustomer()"
        ></div>
      </transition>
      <transition name="slideleft" mode="out-in">
        <OmieModal v-if="showOmieSyncLogs" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showOmieSyncLogs"
          @click="closeOmieSyncLogs()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerModal from '@/components/customers/CustomerModal';
import OmieModal from '@/components/customers/omie/OmieModal';
import SelectCustomerStatuses from '@/components/forms/SelectCustomerStatuses';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';
import { omieAlertsMixin } from '@/mixins/omieAlertsMixin.js';
import { restrictedActionMixin } from '@/mixins/restrictedActionMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [
    returnMessageMixin,
    validationFilterValueMixin,
    omieAlertsMixin,
    restrictedActionMixin,
  ],
  name: 'Customers',
  components: { CustomerModal, SelectCustomerStatuses, OmieModal },
  data() {
    return {
      data: {},
      sortType: localStorage.customerSortType ? localStorage.customerSortType : 'id',
      sortReverse: localStorage.customerSortReverse ? localStorage.customerSortReverse : false,
      amount: localStorage.customerDataAmount ? localStorage.customerDataAmount : 100,
      page: localStorage.customerDataPage ? localStorage.customerDataPage : 1,
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
        name: localStorage.customerFilterName ? localStorage.customerFilterName : '',
        cnpj: localStorage.customerFilterCnpj ? localStorage.customerFilterCnpj : '',
        status: localStorage.customerFilterStatus ? localStorage.customerFilterStatus : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
    showOmieSyncLogs() {
      return this.$store.state.showOmieSyncLogs;
    },
  },
  methods: {
    async isRunningSyncOmie() {
      const url = `${baseApiUrl}/v1/life-cycle-integrations/params`;
      let response = await axios.get(url);
      console.log(1);
      return response.data.omie_customers == 1 ? true : false;
    },
    changeStatus(customerId) {
      const url = `${baseApiUrl}/v1/customer/status/${customerId}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
      localStorage.setItem('customerFilterName', this.filters.name);
      localStorage.setItem('customerFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerFilterStatus', this.filters.status);
      localStorage.setItem('customerDataAmount', this.amount);
      localStorage.setItem('customerDataPage', this.page);
      localStorage.setItem('customerSortType', this.sortType);
      localStorage.setItem('customerSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&amount=${this.amount}&sortType=${
        this.sortType
      }&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    openOmieSyncLogs() {
      this.$store.state.showOmieSyncLogs = true;
    },
    closeOmieSyncLogs() {
      this.$store.state.showOmieSyncLogs = null;
    },
    openSaveCustomer(id, type) {
      this.$store.state.showCustomerSave = id;
      if (id !== 'add') {
        this.$store.state.showStatsCustomer = type ? type : null;
      }
    },
    closeSaveCustomer() {
      this.$store.state.showCustomerSave = null;
      this.$store.state.showStatsCustomer = null;
      this.callData();
    },
    async syncOmie(syncOption, customerId) {
      if (await this.isRunningSyncOmie()) {
        this.logMessageWarning({
          data: {
            message: 'Sincronização em andamento',
          },
        });
        return;
      }

      let url = `${baseApiUrl}/v1/customer/sync/omie?syncOption=${syncOption}`;

      if (syncOption === 3) {
        url = `${baseApiUrl}/v1/customer/sync/omie?syncOption=${syncOption}&customerId=${customerId}`;
      }

      var message = {
        data: {
          message: 'Sincronizando clientes com a Omie...',
        },
      };
      this.logMessage(message);

      axios
        .get(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    syncContaAzul() {
      const url = `${baseApiUrl}/v1/customer/sync/external-id`;
      axios
        .get(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    this.fetchOmieAlerts();
    window.scroll(0, 0);
  },
};
</script>
